import { i18n as I18nInstance } from 'i18next';

type TranslatableNotification = {
  title?: string;
  message: string;
  entityType?: string;
};

const API_ERROR_ENTITY_TYPE = 'ApiError';
const SYSTEM_ERROR_TITLE_PREFIX = 'System Error -';

export const translateNotificationContent = <T extends TranslatableNotification>(
  notification: T,
  i18n: I18nInstance,
): T => {
  if (notification.entityType !== API_ERROR_ENTITY_TYPE) {
    return notification;
  }

  const rawTitle = notification.title?.trim() ?? '';
  const controllerName = rawTitle.startsWith(SYSTEM_ERROR_TITLE_PREFIX)
    ? rawTitle.slice(SYSTEM_ERROR_TITLE_PREFIX.length).trim()
    : '';

  return {
    ...notification,
    title: controllerName
      ? i18n.t('notifications.systemErrorTitleWithController', {
          controller: controllerName,
          defaultValue: 'System error - {{controller}}',
        })
      : i18n.t('notifications.systemErrorTitle', { defaultValue: 'System error' }),
    message: i18n.t('notifications.internalSystemError', {
      defaultValue: 'An internal system error has occurred.',
    }),
  };
};
